import { render, staticRenderFns } from "./busOrder6.vue?vue&type=template&id=50d7a682&scoped=true&"
import script from "./busOrder6.vue?vue&type=script&lang=js&"
export * from "./busOrder6.vue?vue&type=script&lang=js&"
import style0 from "./busOrder6.vue?vue&type=style&index=0&id=50d7a682&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d7a682",
  null
  
)

export default component.exports